// extracted by mini-css-extract-plugin
export default {"text":"index_text_cFsCP","overflowLoading":"index_overflowLoading_YlOe7"};